const blank = require('./blank');

/** /login：保持完整外壳，仅触发一次跳回首页 */
module.exports = function loginRoute(state, emit) {
  if (typeof window !== 'undefined' && !state.loginRouteRedirected) {
    state.loginRouteRedirected = true;
    emit('replaceState', '/');
    setTimeout(() => emit('render'), 0);
  }
  return blank(state, emit);
};
